(function(){
  'use strict';
  var initialized = new WeakSet();
  function getTargets(){
    var targets=[];
    document.querySelectorAll('.section-hof-brand-experience video, .hof-service video, .hof-story video').forEach(function(v){
      targets.push({video:v,critical:!!(v.closest('.hof-screen--hero,.hof-service__hero,.hof-story__media'))});
    });
    return targets;
  }
  function addPoster(video,container){
    if(container.querySelector('.hof-hero-video-poster'))return;
    var url=video.getAttribute('poster')||'';
    if(!url)return;
    var img=document.createElement('img');
    img.className='hof-hero-video-poster';img.src=url;img.alt='';img.setAttribute('aria-hidden','true');img.setAttribute('fetchpriority','high');img.decoding='async';
    container.insertBefore(img,video);
  }
  function reveal(video,container){
    if(video.dataset.hofVideoReady==='true')return;
    video.dataset.hofVideoReady='true';
    requestAnimationFrame(function(){
      video.classList.add('hof-hero-video-ready');
      var poster=container.querySelector('.hof-hero-video-poster');
      if(poster)poster.classList.add('hof-hero-video-poster-hidden');
    });
  }
  function prepare(item){
    var video=item.video;if(!video||initialized.has(video))return;initialized.add(video);
    var container=video.closest('.hof-media-wrap,.hof-service__media-section,.hof-story__media')||video.parentElement;if(!container)return;
    video.classList.add('hof-hero-video');
    video.muted=true;video.playsInline=true;
    video.setAttribute('muted','');video.setAttribute('playsinline','');
    if(item.critical)video.preload='auto';
    if(!video.dataset.hofLoopBound){
      video.dataset.hofLoopBound='true';
      video.addEventListener('ended',function(){try{video.currentTime=0;var p=video.play();if(p&&p.catch)p.catch(function(){});}catch(e){}});
    }
    addPoster(video,container);
    var started=false;
    function start(){
      if(started)return;started=true;video.preload='auto';
      var check=function(){
        try{var buffered=video.buffered.length?video.buffered.end(video.buffered.length-1)-video.currentTime:0;if(video.readyState>=3&&buffered>=0.65){reveal(video,container);video.removeEventListener('progress',check);video.removeEventListener('canplay',check);}}catch(e){reveal(video,container);}
      };
      video.addEventListener('progress',check);video.addEventListener('canplay',check);video.addEventListener('playing',function(){setTimeout(check,100)});
      var p=video.play();if(p&&p.catch)p.catch(function(){started=false;});
    }
    if(item.critical||video.getBoundingClientRect().top<window.innerHeight*1.35)start();
    else if('IntersectionObserver'in window){var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){io.disconnect();start();}});},{rootMargin:'400px 0px'});io.observe(video);}else start();
  }
  function styles(){
    if(document.getElementById('hof-hero-video-fix-styles'))return;
    var s=document.createElement('style');s.id='hof-hero-video-fix-styles';
    s.textContent='.hof-hero-video-poster{position:absolute!important;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;z-index:1;display:block;opacity:1;transition:opacity .35s ease}.hof-hero-video{opacity:0!important;transition:opacity .35s ease;z-index:0!important}.hof-hero-video-ready{opacity:1!important}.hof-hero-video-poster-hidden{opacity:0!important;pointer-events:none}@media(prefers-reduced-motion:reduce){.hof-hero-video,.hof-hero-video-poster{transition:none}}';
    s.textContent += '.section-hof-brand-experience .hof-screen,.section-hof-brand-experience .hof-media-wrap,.section-hof-brand-experience .hof-media,.section-hof-brand-experience .hof-media-fade,.section-hof-brand-experience .hof-media-bottom-fade{border:0!important;outline:0!important;box-shadow:none!important;}';
    s.textContent += '.section-hof-brand-experience .hof-media{mask-image:none!important;-webkit-mask-image:none!important;clip-path:none!important;transform:translateZ(0);backface-visibility:hidden;}';
    s.textContent += '.section-hof-brand-experience .hof-media-wrap{top:-1px!important;bottom:-1px!important;height:calc(100% + 2px)!important;}';
    s.textContent += '.section-hof-brand-experience .hof-screen + .hof-screen{border-top:0!important;margin-top:-1px!important;}';
    document.head.appendChild(s);
  }
  function start(){styles();getTargets().forEach(prepare);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();